import { webPreferences } from './storage/web';

const key = userId => `connectNativeSetupShown:${userId}`;
export const nativeSetup = {
    wasShown: userId => webPreferences.get(key(userId)),
    markShown: userId => webPreferences.set(key(userId), true),
    reset: userId => webPreferences.remove(key(userId)),
};
